<app-header *ngIf="isShowHeader"></app-header>
<div class="body-wrap">
    <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showFooter"></app-footer>
<app-designer-tour></app-designer-tour>
<app-ai-support-chat *ngIf="!isAdminPage"></app-ai-support-chat>
